//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';
import moment from 'moment-timezone';

import { SessionVarsService as ISessionVarsService } from '@services/session-vars-service';
import {
    INSTAGRAM_DASHBOARD_HASHTAG_PAGE_LINK,
    LIBRARY_HASHTAG_PAGE_LINK,
} from '@streams-drawer/model/content-detail-links';
import { getUserHref } from '@streams-drawer/streams-drawer-constants';
import { InstagramWebLinks } from 'app/constants/social-links';

import template from './streams-drawer-list-item.html';
import './streams-drawer-list-item.less';

class StreamsDrawerListItem {
  private static getTimeZoneDate(date: Date, timeZoneId: string) {
    return moment(date).tz(timeZoneId).toDate();
  }

  private static getDateTitle(date: Date, timeZoneId: string) {
    const postTimeMoment = moment(date).tz(timeZoneId);
    return postTimeMoment.format('MMMM Do YYYY, h:mm A z');
  }

  private static getLocationHref(locationId: string) {
    return locationId ? InstagramWebLinks.getLocationLink(locationId) : '';
  }

  public isShareV2Vendor;
  public item;

  public dateTitle;
  public hrefHandlers;
  public locationHref;
  public timeZoneDate;
  public userHref;
  public network;

  constructor(private SessionVarsService: ISessionVarsService) {}

  public $onInit() {
    this.hrefHandlers = {
      user: ({ name }) => getUserHref(name, this.network),
      // Always link Curalate Connect clients to Instagram.com because they
      // don't have access to the rest of the Curalate Webapp
      hashtag: ({ id }) => {
        if (this.isShareV2Vendor) {
          return InstagramWebLinks.getHashtagLink(id);
        } else {
          return INSTAGRAM_DASHBOARD_HASHTAG_PAGE_LINK(id);
        }
      },
    };

    const date = this.item.createdTime;
    const locationId = this.item?.socialDetails?.location?.id;
    const timeZoneId = this.SessionVarsService.getTimeZoneId();
    const username = this.item?.socialDetails?.user?.username;
    this.network = this.item?.socialDetails?.network;

    this.dateTitle = StreamsDrawerListItem.getDateTitle(date, timeZoneId);
    this.locationHref = StreamsDrawerListItem.getLocationHref(locationId);
    this.timeZoneDate = StreamsDrawerListItem.getTimeZoneDate(date, timeZoneId);
    this.userHref = getUserHref(username, this.network);
  }
}

angular.module('curalate').component('streamsDrawerListItem', {
  controller: [
    'SessionVarsService',
    StreamsDrawerListItem,
  ],
  bindings: {
    isShareV2Vendor: '<',
    item: '<',
    shouldShowGalleryText: '<',
    shouldShowConnectText: '<',
  },
  template,
});
